import React, { FC, ReactNode } from 'react';
import cx from 'classnames';
import { Tag } from '../Header';
import { useTheme } from '../../utils/theme';
import styles from './AppBar.css';

type Props = {
  className?: string;
  children: ReactNode;
  tagName?: Tag;
};

const AppBar: FC<Props> = ({
  className,
  children,
  tagName = Tag.NAV
}): JSX.Element => {
  const { isBranded, isGhost, isTakeover } = useTheme();
  const AppBarComponent = tagName;

  return (
    <AppBarComponent
      className={cx(
        styles.component,
        {
          [styles.branded]: isBranded,
          [styles.takeover]: isTakeover,
          [styles.ghost]: isGhost
        },
        className
      )}
    >
      {children}
    </AppBarComponent>
  );
};

export default AppBar;
